import Accordion from './accordion';

let accordions = [];

export const initAccordion = () => {
  accordions.forEach((accordion) => {
    accordion.unload();
  })


  accordions = [...document.querySelectorAll('.accordion')].map((element) => {
    const accordion = new Accordion(element);
    accordion.init();
    return accordion;
  })
}
